import { createI18n } from "vue-i18n";
import en from "./en.json";
import fr from "./fr.json";

const FRENCH = "fr-CA";
const ENGLISH = "en";
const LANGUAGES: string[] = [FRENCH, ENGLISH];

export const SUPPORT_LOCALES = ["en-CA", "fr-CA"];

const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	locale: "fr-CA",
	fallbackLocale: "en-CA",
	messages: {
		en,
		fr,
	},
});

const i18nConfig = {
	i18n: i18n,
	getDefaultBrowserLanguage: getDefaultBrowserLanguage,
	getDefaultLanguage: getDefaultLanguage,
	french: FRENCH,
	english: ENGLISH,
};

/**
 * Permet d'aller chercher la langue par défaut d'un browser
 ***/

function getDefaultBrowserLanguage(): string {
	const res = navigator.language || navigator.languages[0] || FRENCH;
	let language: string = FRENCH;

	if (res.includes("-")) {
		language = res.split("-")[0];
	} else {
		language = res;
	}

	language =
		LANGUAGES.find((lang) => lang.toUpperCase() === language?.toUpperCase()) ||
		FRENCH;

	return language;
}

/**
 * Permet de retourner la langue par défaut sélectionnée
 **/

function getDefaultLanguage(): string {
	return FRENCH;
}

export default i18nConfig;
